import dayjs from 'dayjs';
import { MeterRateTaskType } from '../redux/jobs/jobs.types';

// Reading-history lookups shared by the Excel export builders
// (ExcelWorkbookBuilder.ts, ColumnValueResolver.ts, LegacyShareExportBuilder.ts):
// the most recent reading event/result by readingDate.
export function getLatestReadingEvent(task?: MeterRateTaskType) {
    const arr = task?.readingEvents;
    if (!arr || arr.length === 0) return undefined;
    return arr.reduce((a, b) =>
        dayjs(a.readingDate).isAfter(dayjs(b.readingDate)) ? a : b
    );
}

export function getLatestReadingResult(task?: MeterRateTaskType) {
    const arr = task?.readingResults;
    if (!arr || arr.length === 0) return undefined;
    return arr.reduce((a, b) =>
        dayjs(a.readingDate).isAfter(dayjs(b.readingDate)) ? a : b
    );
}
